import { indexItems } from '@/mocks/homeData';

export default function Index() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            专题合集
          </h2>
          <div className="mt-4 w-16 h-1 bg-primary-500 mx-auto rounded-full"></div>
          <p className="mt-3 text-sm text-foreground-600">全站内容索引导航，快速找到想看的内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group flex items-center gap-4 p-4 md:p-5 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-xl bg-accent-100/80 flex items-center justify-center">
                <span className="text-accent-600 text-xs font-bold font-heading">{item.count}</span>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                  {item.title}
                </h3>
                <p className="mt-1 text-xs md:text-sm text-foreground-600 truncate">
                  {item.description}
                </p>
              </div>
              <i className="ri-arrow-right-s-line text-foreground-400 group-hover:text-primary-500 transition-colors duration-200 flex-shrink-0"></i>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}